export default __webpack_public_path__ + "static/media/sandagen.d06c4541.png";